/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import queryString from "query-string";
import _pickBy from "lodash/pickBy";
import { useDispatch, useSelector } from "react-redux";
import PageLayout from "../containers/PageLayout";
import BaseButton from "./common/BaseButton";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import styled from "styled-components";

const StyledCard = styled(({ isLeft, ...props }) => <Card {...props} />)`
  ${(props) => {
    if (props.isLeft) {
      return "margin-right: 40px; float: right;";
    } else {
      return "margin-left: 40px";
    }
  }};

  text-align: center;
  max-width: 400px;
  height: 350px;

  &.MuiPaper-rounded {
    border-radius: 12px;
  }
`;

const StyledButton = styled(BaseButton)`
  width: 250px;
  margin-top: 45px !important;
`;

const StyledTypographyCardTitle = styled(Typography)`
  font-weight: 450 !important;
  font-size: 30px !important;
  line-height: normal !important;
`;

const StyledTypographyCardDetails = styled(Typography)`
  margin-left: 60px !important;
  margin-right: 60px !important;
  font-size: 14px !important;
`;

const StyledCardContent = styled(CardContent)`
  text-align: center;
  margin-top: 30px;
`;

const StyledCardActions = styled(CardActions)`
  justify-content: center;
`;

const LandingPage = () => {
  const dispatch = useDispatch();

  const spotFilters = useSelector((state) => state.spotFilters);
  const trackingFilters = useSelector((state) => state.filters);

  const getDefaultFilters = (page) => {
    const filters = page === "availableroutes" ? spotFilters : trackingFilters;
    const nonNullFilters = _pickBy(filters, (value) => value !== null);
    return queryString.stringify({
      ...nonNullFilters,
    });
  };

  return (
    <PageLayout documentTitle="RouteConnect™" data-testid="landing-page">
      <Grid
        container
        direction="row"
        alignItems="center"
        justify="center"
        style={{ height: "100%" }}
      >
        <Grid item xs={6}>
          <StyledCard isLeft={true}>
            <StyledCardContent>
              <StyledTypographyCardTitle gutterBottom>
                RouteConnect™
                <br /> Available Routes
              </StyledTypographyCardTitle>
              <StyledTypographyCardDetails>
                View uncovered and available routes for the UPS Carrier
                Management Group.
              </StyledTypographyCardDetails>
              <StyledCardActions>
                <StyledButton
                  data-testid="launch-availableroutes"
                  component={Link}
                  to={`/availableroutes/?${getDefaultFilters("availableroutes")}`}
                >
                  Launch
                </StyledButton>
              </StyledCardActions>
            </StyledCardContent>
          </StyledCard>
        </Grid>
        <Grid item xs={6}>
          <StyledCard>
            <StyledCardContent>
              <StyledTypographyCardTitle gutterBottom>
                RouteConnect™
                <br /> Tracking
              </StyledTypographyCardTitle>
              <StyledTypographyCardDetails>
                Manage tracking and provide visibility on covered routes for the
                UPS Carrier Management Group.
              </StyledTypographyCardDetails>
              <StyledCardActions>
                <StyledButton
                  data-testid="launch-tracking"
                  component={Link}
                  to={`/tracking/?${getDefaultFilters("tracking")}`}
                >
                  Launch
                </StyledButton>
              </StyledCardActions>
            </StyledCardContent>
          </StyledCard>
        </Grid>
      </Grid>
    </PageLayout>
  );
};

export default LandingPage;
